/**
 * Page view tracker - sends every navigation to the analytics service.
 * Captures: page URL, title, referrer, screen size, language, user identity.
 */

const TRACK_URL = '/api/analytics/track';
let _lastTrackedPage = null;

function getSessionId() {
  let sid = sessionStorage.getItem('_is_sid');
  if (!sid) {
    sid = Math.random().toString(36).substring(2) + Date.now().toString(36);
    sessionStorage.setItem('_is_sid', sid);
  }
  return sid;
}

export function trackPageView(page, user) {
  // Avoid duplicate tracking of the same page
  if (page === _lastTrackedPage) return;
  _lastTrackedPage = page;

  const payload = {
    page: page,
    title: document.title,
    referrer: document.referrer || '',
    screen_width: window.screen.width,
    screen_height: window.screen.height,
    language: navigator.language,
    session_id: getSessionId(),
    user_email: user?.email || null,
  };

  // Use sendBeacon for reliability (survives page unload), fall back to fetch
  const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
  if (navigator.sendBeacon) {
    navigator.sendBeacon(TRACK_URL, blob);
  } else {
    fetch(TRACK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  }
}
